import omit from 'lodash/omit';

import { replaceNestedWithId } from '../../utils/replace-nested-with-id';

export function transformForRendering(invoice) {
  let transformedObject = invoice;
  ['owner', 'ccInternalUser', 'account'].forEach(fieldName => {
    transformedObject = replaceNestedWithId(transformedObject, fieldName);
  });
  return transformedObject;
}

export function getFieldsToRemove() {
  return [
    'id',
    'products',
    'opportunity',
    'ownerId',
    'owner',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
    'quote',
    'name',
  ];
}

export function transformForPatch(model) {
  const partialInvoice = omit(model, getFieldsToRemove());

  partialInvoice.bookingEntries = model.bookingEntries.map(entry => entry.id);

  return partialInvoice;
}
